import { getStatusIcon } from "./components/AbandonedVehicleStatusIcon";
import { memo } from "react";
import { showAbandonedVehicleStatus } from "./api/EnumUtils";
import { vehicleThumbnailAfter } from "./api/Url";
import { Match } from "./loaders/abandonedVehicleLoader";
import { RowComponentProps } from "react-window";

interface AbandonedVehicleProps {
    vehicle:     Match;
    onClick:     ( match: Match ) => void;
    selectedId?: number;
}

export function AbandonedVehicleItem( { vehicle, onClick, selectedId }: AbandonedVehicleProps ) {
    const isSelected = selectedId === vehicle.abandonedVehicleId;
    const bg = isSelected ? "bg-primary text-white" : "bg-body text-body";
    const className = `d-flex align-items-center match-item border-2 border-bottom ps-4 p-3 ${bg} hover-highlight`;
    return <div
        style={{ cursor: "pointer", height: "124px" }}
        className={className}
        onClick={ () => onClick( vehicle ) }>
        <div className="position-relative d-flex flex-column align-items-center me-3 flex-shrink-0">
            <div className="position-absolute" style={{ top: -12, left: -10 }}>
                {getStatusIcon( vehicle.status.status )}
            </div>
            <img
                loading="lazy"
                src={vehicleThumbnailAfter( vehicle.abandonedVehicleId )}
                alt={`${vehicle.abandonedVehicleId} thumbnail`}
                className="img-px match-item-thumbnail border rounded bg-black" />
        </div>
        <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-1 small fw-bold">
                #{vehicle.abandonedVehicleId} {showAbandonedVehicleStatus( vehicle.status.status )}
            </div>
            <div className="small text-muted">
                <div className="d-flex gap-1">
                    <div className="font-monospace">
                        {( vehicle.similarity * 100 ).toFixed( 0 )}%
                    </div>
                    <div>Similarity</div>
                </div>
                <div>
                    {/* nothing in here... */}
                </div>
            </div>
        </div>
    </div>;
}

export const AbandonedVehicleItemMemo = memo( AbandonedVehicleItem );

export function Row( { index, style, vehicles, selectedId, onClick }: RowComponentProps<{
    selectedId?: number;
    vehicles:    Match[];
    onClick:     ( m: Match ) => void;
}> ) {
    const vehicle = vehicles[index];
    return <div style={{ ...style, overflow: "hidden" }}>
        <AbandonedVehicleItemMemo
            selectedId={selectedId}
            vehicle={vehicle}
            onClick={onClick} />
    </div>;
};